export default __webpack_public_path__ + "static/media/cif-tt.49a04d56.svg";